/**
 * Spellslinger rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Start the game with 4 spells in hand.
 *    Tap → Play or draw a site."
 *
 * The second line is the standard avatar "Tap" ability shared by every
 * avatar (no override needed). Only the first line is a meaningful
 * deviation from the rulebook default. One extra Spellbook card at
 * the opening draw, no change to Atlas.
 *
 * The mulligan max stays at the default 3: the July 2024 Sorcery rule
 * caps the total regardless of opening hand size.
 */
export const SPELLSLINGER_RULES = {
  openingHand: {
    spellbook: 4,
    // atlas unchanged. Inherits the default of 3 via deep-merge.
  },
};
